import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  PamlabApiServiceService,
  DataService,
  RouteService,
} from '@/shared/services';
import {
  CourseComboReturn,
  StudentTypeSelection,
} from '../../../../../server/types';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'course-combinations-form',
  templateUrl: './course-combinations-form.component.html',
  styleUrls: ['./course-combinations-form.component.css'],
  standalone: false,
})
export class CourseCombinationsFormComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  private prevSelectedCrsLevels: string[] = ['Any'];
  // course combination form group
  public courseComboForm = new FormGroup({
    student_type: new FormControl<StudentTypeSelection>('all', [
      Validators.required,
    ]),
    semester: new FormControl('all', [Validators.required]),
    combo_size: new FormControl('4', [Validators.required]),
    course_levels: new FormControl<string[]>(['Any'], [Validators.required]),
  });

  constructor(
    private _dialog: MatDialog,
    private _apiService: PamlabApiServiceService,
    private _dataService: DataService,
    private _routeService: RouteService,
  ) {}

  ngOnInit(): void {
    this.courseComboSubmit();
  }

  ngOnDestroy(): void {
    setTimeout(() => {
      this.subscription.unsubscribe();
    }, 3000);
  }

  // courseComboForm get data from api by passing user input from form
  courseComboSubmit() {
    // Allows the tool header component to render first
    setTimeout(() => {
      this._dataService.setPendingData(true);
    });

    const params = {
      student_type: this.courseComboForm.value.student_type!,
      semester: this.courseComboForm.value.semester!,
      combo_size: Number(this.courseComboForm.value.combo_size!),
      course_levels: this.courseComboForm.value.course_levels!,
    };

    this.subscription.add(
      this._apiService.getCourseCombo(params).subscribe({
        next: (data: CourseComboReturn) => {
          this._dataService.setData({ data });
          this._dataService.setPendingData(false);
        },
        error: (errorRes: HttpErrorResponse) => {
          if (errorRes.status === 401) {
            this._routeService.navigate(environment['login_url']);
          }
          this._dataService.setData({ error: errorRes.error });
          this._dataService.setPendingData(false);
        },
      }),
    );
  }

  // close popup _dialog after form is submitted
  closeDialog() {
    this._dialog.closeAll();
  }

  // Error message when user leaves form fields empty
  getErrorMessage() {
    return 'You must select a value';
  }

  handleCourseLevelsChange(event: MatSelectChange) {
    const values = event.value as string[];

    if (!this.prevSelectedCrsLevels.includes('Any') && values.includes('Any')) {
      this.courseComboForm.patchValue({ course_levels: ['Any'] });
    }

    if (
      this.prevSelectedCrsLevels.includes('Any') &&
      values.includes('Any') &&
      values.length > 1
    ) {
      this.courseComboForm.patchValue({
        course_levels: values.filter((v) => v !== 'Any'),
      });
    }
    this.prevSelectedCrsLevels = values;
  }
}
